<div class="dialog" [class.blocked]="isBlocked">
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>
                {{
                    'COMPLAINT|Reklamacja została zmodyfikowana przez innego użytkownika. Dane w tym oknie są nieaktualne i zostały zablokowane do edycji. Zamknij okno i otwórz ponownie, aby zobaczyć aktualne dane.'
                        | translate
                }}
            </p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Edycja danych reklamującego' | translate }}</h3>
        <button iccIconButton (click)="close()" appearance="flat" type="button">
            <icc-icon name="close"></icc-icon>
        </button>
    </div>

    <form
        [formGroup]="complaintFormValidatedFields"
        class="dialog-body complainant-form"
        (submit)="save()"
    >
        <div class="complainant-form__input">
            <icc-input
                type="text"
                [value]="complaint.clientName"
                [size]="'medium'"
                [name]="'clientName'"
                [prefixIcon]="'person'"
                (valueChange)="onComplainantFieldChange('clientName', $event)"
                [required]="true"
                [placeholder]="'PERSON|Imię i Nazwisko' | translate"
                [label]="'PERSON|Imię i Nazwisko' | translate"
                [maxLength]="255"
            ></icc-input>
        </div>
        <div class="complainant-form__input">
            <icc-input
                formControlName="clientEmail"
                type="email"
                [size]="'medium'"
                [name]="'clientEmail'"
                [prefixIcon]="'email'"
                [required]="true"
                (valueChange)="onComplainantFieldChange('clientEmail', $event)"
                [placeholder]="'CONTACT|Adres e-mail' | translate"
                [label]="'CONTACT|Adres e-mail' | translate"
                [emailValidation]="true"
            ></icc-input>
        </div>
        <div class="complainant-form__input">
            <icc-input
                formControlName="clientPhoneNumber"
                type="text"
                [size]="'medium'"
                [name]="'clientPhoneNumber'"
                [prefixIcon]="'phone'"
                [required]="true"
                (valueChange)="onComplainantFieldChange('clientPhoneNumber', $event)"
                [placeholder]="'CONTACT|Nr telefonu' | translate"
                [label]="'CONTACT|Nr telefonu' | translate"
                [phoneNumberValidation]="true"
                [phoneNumberErrorMessage]="
                    'CONTACT|Niepoprawny format numeru telefonu: \'+\' - dozwolony tylko jako pierwszy opcjonalny znak, następnie dozwolone znaki ze zbioru: 0123456789\(\),;#-'
                        | translate
                "
            ></icc-input>
        </div>

        <div class="complainant-form__radio">
            <icc-radio
                name="address-mode"
                [value]="'exact'"
                [checked]="addressMode === 'exact'"
                [(ngModel)]="addressMode"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onAddressModeChange($event)"
            >
                {{ 'COMPLAINT|Podaję dokładny adres instalacji' | translate }}
            </icc-radio>
            <icc-radio
                name="address-mode"
                [value]="'map'"
                [checked]="addressMode === 'map'"
                [(ngModel)]="addressMode"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onAddressModeChange($event)"
            >
                {{ 'COMPLAINT|Brak adresu – zaznaczę lokalizację na mapie' | translate }}
            </icc-radio>
        </div>

        <ng-container *ngIf="addressMode === 'exact'">
            <div class="complainant-form__input">
                <icc-input
                    formControlName="addressLine1"
                    type="text"
                    [value]="addressLine1"
                    [size]="'medium'"
                    [name]="'addressLine1'"
                    [prefixIcon]="'location'"
                    [required]="true"
                    (valueChange)="onAddressFieldChange('addressLine1', $event)"
                    (blurChange)="onInstallationAddressChange()"
                    [placeholder]="'COMPLAINT|Ulica' | translate"
                    [label]="'COMPLAINT|Ulica' | translate"
                    [maxLength]="100"
                ></icc-input>
            </div>
        </ng-container>

        <ng-container *ngIf="addressMode === 'map'">
            <div class="complainant-form__input">
                <icc-input
                    type="text"
                    [value]="complaint.locationDescription || ''"
                    [size]="'medium'"
                    [name]="'locationDescription'"
                    [prefixIcon]="'location'"
                    [required]="false"
                    [supportText]="
                        'COMPLAINT|To pole jest informacyjne i nie bierze udziału w geolokalizacji'
                            | translate
                    "
                    (valueChange)="onLocationDescriptionChange($event)"
                    [placeholder]="'COMPLAINT|Opis lokalizacji' | translate"
                    [label]="'COMPLAINT|Opis lokalizacji' | translate"
                    [maxLength]="255"
                ></icc-input>
            </div>
        </ng-container>

        <div class="complainant-form__row">
            <div class="complainant-form__input">
                <icc-input
                    formControlName="postalCode"
                    type="text"
                    [value]="postalCode"
                    [size]="'medium'"
                    [name]="'postalCode'"
                    [prefixIcon]="'location'"
                    [required]="true"
                    (valueChange)="onAddressFieldChange('postalCode', $event)"
                    (blurChange)="onInstallationAddressChange()"
                    [placeholder]="'COMPLAINT|Kod pocztowy' | translate"
                    [label]="'COMPLAINT|Kod pocztowy' | translate"
                    [maxLength]="10"
                ></icc-input>
            </div>
            <div class="complainant-form__input">
                <icc-input
                    formControlName="city"
                    type="text"
                    [value]="city"
                    [size]="'medium'"
                    [name]="'city'"
                    [prefixIcon]="'location'"
                    [required]="true"
                    (valueChange)="onAddressFieldChange('city', $event)"
                    (blurChange)="onInstallationAddressChange()"
                    [placeholder]="'COMPLAINT|Miejscowość' | translate"
                    [label]="'COMPLAINT|Miejscowość' | translate"
                    [maxLength]="100"
                ></icc-input>
            </div>
        </div>

        <div
            *ngIf="apiLoaded && installationAddress && !mapLoadError"
            class="complainant-form__map"
        >
            <google-map [zoom]="mapZoom" [center]="installationAddress!">
                <map-marker
                    [position]="installationAddress!"
                    [options]="markerOptions"
                    (mapDragend)="onMarkerDragEnd($event)"
                ></map-marker>
            </google-map>
        </div>

        <div *ngIf="mapLoadError" class="complainant-form__map-error">
            <p>
                {{
                    'COMPLAINT|Brak połączenia z serwisem Map. Proszę spróbować ponownie lub opisać lokalizację słownie w polu "Opis lokalizacji"'
                        | translate
                }}
            </p>
        </div>
    </form>

    <div class="dialog-footer">
        <button iccButton appearance="outline" type="button" (click)="close()">
            {{ 'INTERFACE|Anuluj' | translate }}
        </button>
        <button
            iccButton
            appearance="primary"
            type="button"
            (click)="save()"
            [disabled]="isBlocked"
        >
            {{ 'INTERFACE|Zapisz' | translate }}
        </button>
    </div>
</div>
<div class="curtain" (click)="close()"></div>
